import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams, Link } from "react-router-dom";
import { BiLoaderAlt } from "react-icons/bi";
import MetaHead from "../../../Common/Metahead";
import { useTranslation } from "react-i18next";
import { AiOutlineClose } from "react-icons/ai";
import { outReachDetails } from "../../../../stores/actions/outreach.actions.types";

const DetailOutreachPage = ({ outReachDetails }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const [outreach, setOutreach] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      setLoading(true);
      outReachDetails({
        id,
        callback: (data) => {
          if (data?.success) {
            setLoading(false);
            setOutreach(data?.data?.data);
          }
        },
      });
    }
  }, [id, outReachDetails]);

  if (loading) {
    return (
      <div className='flex items-center justify-center min-h-screen'>
        <BiLoaderAlt className='animate-spin text-5xl text-primary dark:text-white' />
      </div>
    );
  }

  if (!outreach) {
    return (
      <div className='flex items-center justify-center min-h-screen text-gray-500 dark:text-gray-400'>
        No outreach details available.
      </div>
    );
  }

  return (
    <div className='flex items-center justify-center p-4'>
      <MetaHead title={t("outreach-details")} />
      <div className='bg-white dark:bg-boxdark rounded-lg p-6 w-full max-w-xl relative'>
        <button className='absolute top-4 right-4 text-gray-500 dark:text-gray-400 text-xl'>
          <AiOutlineClose onClick={() => navigate(-1)} />
        </button>

        <div className='divide-y p-5 divide-gray-200 dark:divide-gray-700'>
          <div className='flex justify-between py-2 text-gray-700 dark:text-gray-300'>
            <span className='font-bold'>Company:</span>
            <span>{outreach?.companyName}</span>
          </div>
          <div className='flex justify-between py-2 text-gray-700 dark:text-gray-300'>
            <span className='font-bold'>Name:</span>
            <span>{outreach?.name}</span>
          </div>
          <div className='flex justify-between py-2 text-gray-700 dark:text-gray-300'>
            <span className='font-bold'>Email:</span>
            <span>{outreach?.email}</span>
          </div>
          <div className='flex justify-between py-2 text-gray-700 dark:text-gray-300'>
            <span className='font-bold'>Phone:</span>
            <span>{outreach?.phone}</span>
          </div>
          <div className='flex justify-between py-2 text-gray-700 dark:text-gray-300'>
            <span className='font-bold'>Created At:</span>
            <span>{new Date(outreach?.createdAt).toLocaleDateString()}</span>
          </div>
          <div className='flex justify-between py-2 text-gray-700 dark:text-gray-300'>
            <span className='font-bold'>Updated At:</span>
            <span>{new Date(outreach?.updatedAt).toLocaleDateString()}</span>
          </div>
        </div>

        <Link
          to={`/outreach/update/${id}`}
          className='mt-4 block w-full bg-primary text-white py-2 rounded-lg text-center font-semibold'
        >
          Update Outreach
        </Link>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ loading: state?.app?.visible });

export default connect(mapStateToProps, { outReachDetails })(
  DetailOutreachPage
);
